import cs from './cs.js';
import de from './de.js';
import en from './en.js';
import es from './es.js';
import fr from './fr.js';
import it from './it.js';
import ja from './ja.js';
import ko from './ko.js';
import pt from './pt.js';
import ru from './ru.js';
import zh from './zh.js';
const overrides = {
    cs,
    de,
    en,
    es,
    fr,
    it,
    ja,
    ko,
    pt,
    ru,
    zh
};
/**
 * Returns locale-specific PageSEO for a pathname+lang pair, or null if no override exists.
 * Strips the leading /{lang} segment before lookup so callers can pass the raw URL path.
 */
export function getLocalePageSEO(pathname, lang) {
    const langOverrides = overrides[lang];
    if (!langOverrides)
        return null;
    const stripped = pathname.replace(new RegExp(`^/${lang}(?=/|$)`), '') || '/';
    const clean = stripped.replace(/\/$/, '') || '/';
    return langOverrides[clean] ?? langOverrides[clean + '/'] ?? null;
}
